import React from 'react';
import { Center, ChakraProvider, DarkMode, VStack, Text } from '@chakra-ui/react';
import { CardSpinner } from './domain/card/component/CardSpinner';
import theme from './styles/theme';

/**
 * Unified loading fallback for lazy-loaded application routes.
 * Wrapped with ChakraProvider and DarkMode to ensure consistent styling
 * before the main app providers are loaded.
 */
export const AppLoadingFallback: React.FC = () => {
    return (
        <ChakraProvider theme={theme}>
            <DarkMode>
                <Center height="100vh" bg="#0A0A0A">
                    <VStack spacing={4}>
                        <CardSpinner />
                    </VStack>
                </Center>
            </DarkMode>
        </ChakraProvider>
    );
};
